import { render, staticRenderFns } from "./core-details-form.component.vue?vue&type=template&id=2883f244"
import script from "./core-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./core-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2883f244')) {
      api.createRecord('2883f244', component.options)
    } else {
      api.reload('2883f244', component.options)
    }
    module.hot.accept("./core-details-form.component.vue?vue&type=template&id=2883f244", function () {
      api.rerender('2883f244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/detail-forms/core-details-form/core-details-form.component.vue"
export default component.exports